import { ChangeEvent } from 'react'
import { FormField } from '../../../../Components'
import { defineMessages, useIntl } from 'react-intl'

export const MSG = defineMessages({
  label: {
    id: 'BombBomb.form.email.label',
    defaultMessage: 'To (comma separate emails)'
  },
  placeholder: {
    id: 'BombBomb.form.email.placeholder',
    defaultMessage: 'Email Address'
  }
})

export interface BombBombSendFormEmailProps {
  email: string
  setEmail(email: string): void
}

export const BombBombSendFormEmail = ({ email, setEmail }: BombBombSendFormEmailProps) => {
  const intl = useIntl()

  return (
    // @ts-ignore
    <FormField
      required
      value={email}
      name='recorder-emails'
      placeholder={intl.formatMessage(MSG.placeholder)}
      onChange={(e: ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
    >
      {intl.formatMessage(MSG.label)}
    </FormField>
  )
}
